import { i18n } from '@/i18n/index'
import { globalize } from './globalize'

export function formatVerificationStatus (value) {
  if (!value) return '-'
  const globalization = `verification-status.lbl-${value}`
  if (i18n.exists(globalization)) {
    return globalize(globalization)
  }
  return value
}
